// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PranavamTV {
    width: 100%;
    padding: 20px 0px;
}

.PranavamTV .title {
    font-size: 1.2rem;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    flex-direction: row;
}

.PranavamTV .video-section iframe {
    width: 100%;
    height: 45vh;
    border-radius: 10px;
}

.video-section {
    display: flex;
    flex-direction: row;
    gap: 2%;
}

.PranavamTV .main {
    width: 50%;
}

.PranavamTV .other {
    display: flex;
    flex-direction: column;
    gap: 1%;
    width: 50%;
}

.PranavamTV .video-section .embed {
    display: flex;
    font-size: 0.8rem;
    gap: 5px;
    /* height: -webkit-fill-available; */
    width: auto;
}

/* .PranavamTV .video-section .embed .video-title {
    flex: 0 0 50%;
} */

.youtubeEmbed {
    border-radius: 10px;
    flex: 1 1;
    height: 10vh;
    padding: 10px;
    position: relative;
}

.youtubeEmbed:hover {
    filter: blur(0);  /* Remove blur on hover */
}

.PranavamTV .embed .add-info {
    font-size: 0.6rem;
    display: flex;
    align-items: center;
    gap: 5px;
}

.PranavamTV .embed .add-info .comment,
.PranavamTV .embed .add-info .views {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}

.video-section {
    display: flex;
    gap: 20px;
}

.main {
    flex: 2 1;
}

.other {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.embed {
    display: flex;
    flex-direction: row;
    gap: 1rem; 
    padding: 0.5rem;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
}

.video-title {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.video-img{
    max-width: 8rem;
}

.add-info {
    display: flex;
    justify-content: space-between;
}

.comment, .views {
    display: flex;
    align-items: center;
    gap: 5px;
}

@media (max-width: 768px) {
    .title {
        flex-direction: column;
        align-items: center;
    }

    .video-section {
        flex-direction: column;
    }

    .main {
        width: 100%;
    }

    .other {
        width: 100%;
        flex-direction: row;
        overflow-x: auto;
        gap: 10px;
    }

    .embed {
        width: 80%;
        flex: none;
    }

    .video-title .text {
        font-size: 0.8rem;
    }
    .video-title .sub-text{
        font-size: 0.7rem;
    }
    .video-img{
        max-width: 6rem;
    }

    .add-info .count {
        font-size: 0.8rem;
    }
    .PranavamTV .main {
        width: 100%;
    }
    
    .PranavamTV .other {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/pranavam_tv/pranavam.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,QAAQ;IACR,oCAAoC;IACpC,WAAW;AACf;;AAEA;;GAEG;;AAEH;IACI,mBAAmB;IACnB,SAAO;IACP,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe,GAAG,yBAAyB;AAC/C;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,UAAU;QACV,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".PranavamTV {\n    width: 100%;\n    padding: 20px 0px;\n}\n\n.PranavamTV .title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 0;\n    flex-direction: row;\n}\n\n.PranavamTV .video-section iframe {\n    width: 100%;\n    height: 45vh;\n    border-radius: 10px;\n}\n\n.video-section {\n    display: flex;\n    flex-direction: row;\n    gap: 2%;\n}\n\n.PranavamTV .main {\n    width: 50%;\n}\n\n.PranavamTV .other {\n    display: flex;\n    flex-direction: column;\n    gap: 1%;\n    width: 50%;\n}\n\n.PranavamTV .video-section .embed {\n    display: flex;\n    font-size: 0.8rem;\n    gap: 5px;\n    /* height: -webkit-fill-available; */\n    width: auto;\n}\n\n/* .PranavamTV .video-section .embed .video-title {\n    flex: 0 0 50%;\n} */\n\n.youtubeEmbed {\n    border-radius: 10px;\n    flex: 1;\n    height: 10vh;\n    padding: 10px;\n    position: relative;\n}\n\n.youtubeEmbed:hover {\n    filter: blur(0);  /* Remove blur on hover */\n}\n\n.PranavamTV .embed .add-info {\n    font-size: 0.6rem;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.PranavamTV .embed .add-info .comment,\n.PranavamTV .embed .add-info .views {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n}\n\n.video-section {\n    display: flex;\n    gap: 20px;\n}\n\n.main {\n    flex: 2;\n}\n\n.other {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.embed {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem; \n    padding: 0.5rem;\n    border: 1px solid #d9d9d9;\n    border-radius: 10px;\n}\n\n.video-title {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n.video-img{\n    max-width: 8rem;\n}\n\n.add-info {\n    display: flex;\n    justify-content: space-between;\n}\n\n.comment, .views {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n@media (max-width: 768px) {\n    .title {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .video-section {\n        flex-direction: column;\n    }\n\n    .main {\n        width: 100%;\n    }\n\n    .other {\n        width: 100%;\n        flex-direction: row;\n        overflow-x: auto;\n        gap: 10px;\n    }\n\n    .embed {\n        width: 80%;\n        flex: none;\n    }\n\n    .video-title .text {\n        font-size: 0.8rem;\n    }\n    .video-title .sub-text{\n        font-size: 0.7rem;\n    }\n    .video-img{\n        max-width: 6rem;\n    }\n\n    .add-info .count {\n        font-size: 0.8rem;\n    }\n    .PranavamTV .main {\n        width: 100%;\n    }\n    \n    .PranavamTV .other {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
